module.exports = __webpack_public_path__ + "static/media/app.bb5810d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Examples/assets/app.png
// module id = 457
// module chunks = 0